export default function TermsPage() {
  return (
    <div className="py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">الشروط والأحكام</h1>
        <p className="text-gray-500 text-sm mb-8">Terms & Conditions</p>

        <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 space-y-8">
          {/* 1. Subscription Terms */}
          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">1. شروط الاشتراك</h2>
            <ul className="space-y-2 text-sm text-gray-700">
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>الاشتراك شهري ويبدأ من تاريخ الدفع</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>الحد الأقصى ٦ غسلات في الشهر</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>الاشتراك لسيارة واحدة فقط برقم لوحة محدد</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>لا يمكن نقل الاشتراك لسيارة أخرى</span>
              </li>
            </ul>
          </section>

          {/* 2. Vehicle Verification */}
          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">2. التحقق من السيارة</h2>
            <ul className="space-y-2 text-sm text-gray-700">
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>يجب رفع صورة حقيقية للسيارة تظهر لوحة الأرقام خلال ٢٤ ساعة من الاشتراك</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>لا يمكن استخدام الخدمة بدون التحقق من صورة السيارة</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>ستطلب المغاسل رؤية صورة السيارة المُحققة قبل تقديم الخدمة</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>يجب أن تتطابق لوحة الأرقام في الصورة مع البيانات المسجلة</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>في حال عدم التحقق خلال ٢٤ ساعة، يتم تعليق الاشتراك</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>الصور المزيفة أو المعدلة تؤدي إلى إلغاء الاشتراك فوراً</span>
              </li>
            </ul>
          </section>

          {/* 3. Queue Cancellation */}
          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">3. إلغاء الطابور</h2>
            <ul className="space-y-2 text-sm text-gray-700">
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>يمكنك إلغاء طلبك من الطابور فقط قبل بدء غسيل السيارة</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>بمجرد بدء غسيل سيارتك، لا يمكن الإلغاء</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>لن يتم احتساب الغسلة المُلغاة من حصتك الشهرية</span>
              </li>
            </ul>
          </section>

          {/* 4. Refund */}
          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">4. سياسة الاسترداد</h2>
            <ul className="space-y-2 text-sm text-gray-700">
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>لا يوجد استرداد للاشتراكات المُستخدمة</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>في حالة مشكلة تقنية، تواصل مع الدعم</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>الغسلات غير المستخدمة لا تُنقل للشهر التالي</span>
              </li>
            </ul>
          </section>

          {/* 5. Service Terms */}
          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">5. شروط الخدمة</h2>
            <ul className="space-y-2 text-sm text-gray-700">
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>الخدمة متاحة في المغاسل الشريكة فقط</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>أوقات الانتظار تقديرية وقد تختلف</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>المنصة غير مسؤولة عن أضرار السيارة أثناء الغسيل</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>يجب إبراز رمز QR صالح للحصول على الخدمة</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>المنصة تحتفظ بحق تعليق أو إلغاء الاشتراكات المُسيئة</span>
              </li>
            </ul>
          </section>

          {/* 6. Cancellation */}
          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">6. إلغاء الاشتراك</h2>
            <h3 className="text-sm font-bold text-gray-800 mb-2">إلغاء المستخدم:</h3>
            <ul className="space-y-2 text-sm text-gray-700 mb-4">
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>يمكنك إيقاف التجديد التلقائي في أي وقت</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>ستبقى الخدمة متاحة حتى نهاية فترة الاشتراك الحالية</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>لا يوجد استرداد للمبالغ المدفوعة</span>
              </li>
            </ul>

            <h3 className="text-sm font-bold text-gray-800 mb-2">إلغاء المنصة:</h3>
            <ul className="space-y-2 text-sm text-gray-700">
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>يحق للمنصة إلغاء الاشتراك فوراً في حالة مخالفة الشروط</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>قرار المنصة نهائي في حالات المخالفة</span>
              </li>
            </ul>
          </section>

          {/* 7. Violations */}
          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">7. المخالفات</h2>
            <p className="text-sm text-gray-600 mb-2">المخالفات التي قد تؤدي لإلغاء الاشتراك:</p>
            <ul className="space-y-2 text-sm text-gray-700">
              <li className="flex gap-2">
                <span className="text-red-500 font-bold shrink-0">-</span>
                <span>الاحتيال أو تزوير البيانات</span>
              </li>
              <li className="flex gap-2">
                <span className="text-red-500 font-bold shrink-0">-</span>
                <span>إساءة استخدام الخدمة</span>
              </li>
              <li className="flex gap-2">
                <span className="text-red-500 font-bold shrink-0">-</span>
                <span>سلوك غير لائق مع موظفي المغاسل</span>
              </li>
              <li className="flex gap-2">
                <span className="text-red-500 font-bold shrink-0">-</span>
                <span>استخدام الاشتراك لسيارة غير مسجلة</span>
              </li>
              <li className="flex gap-2">
                <span className="text-red-500 font-bold shrink-0">-</span>
                <span>محاولة التحايل على نظام الغسلات</span>
              </li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
}
